import styled from '@emotion/styled';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import GrayCross from '../icons/gray-cross';
import PinkCircleCheck from '../icons/pink-circle-check';

const ComponentsWrapper = styled.div`
  display: flex;
  width: 100%;
  > div {
    display: flex;
    flex-direction: column;
    p {
      margin-left: 0.625em;
      margin-bottom: 0;
      height: 2em;
      text-transform: capitalize;
    }
    img {
      height: 2em;
    }
  }
`;

const HeightFixed = styled.div`
  display: block;
  height: 2em;
`;

const ComponentReview = ({ components }) => (
  <ComponentsWrapper>
    <div>
      {Object.values(components).map((value, key) => (
        <HeightFixed>{value == 'YES' ? <PinkCircleCheck /> : <GrayCross />}</HeightFixed>
      ))}
    </div>
    <div>
      {Object.keys(components).map((value, key) => (
        <HeightFixed>
          <p>{value.replace(/_/g, ' ')}</p>
        </HeightFixed>
      ))}
    </div>
  </ComponentsWrapper>
);

const mapStateToProps = state => ({
  components: state.formData.components,
});

export default connect(mapStateToProps)(ComponentReview);
